import { Box, Center, Stack, Text } from '@chakra-ui/react';
import NextLink from 'next/link';

import { useRouteMatch } from '@/hooks/useRouteMatch';

export const FooterButton: React.FC<{
  href: string;
  isExact?: boolean;
}> = (props) => {
  const match = useRouteMatch(props.href, { isExact: props.isExact });

  return (
    <Center
      h="20"
      borderTop="2px"
      flex="1"
      borderTopColor={!!match ? 'primary.500' : 'transparent'}
      as={NextLink}
      href={props.href}
    >
      <Stack
        align="center"
        spacing="2"
        color={!!match ? 'primary.500' : 'gray.500'}
      >
        {props.children}
      </Stack>
    </Center>
  );
};

export const FooterButtonLabel: React.FC = (props) => {
  return (
    <Text fontSize="xs" lineHeight="shorter" align="center">
      {props.children}
    </Text>
  );
};

export const Footer: React.FC = (props) => {
  return (
    <Box bg="white" borderTop="1px" borderTopColor="gray.100" {...props}>
      <Stack direction="row" spacing="0">
        {props.children}
      </Stack>
    </Box>
  );
};
